module.exports = __webpack_public_path__ + "media/pay_success.71a381a0.mp3";